"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _Saturation = require("../Saturation");

var _Hue = require("../Hue");

var _Fields = require("../Fields");

require("./styles.css");

var ColorPicker = function ColorPicker(_ref) {
  var width = _ref.width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? width : _ref$height,
      color = _ref.color,
      onChange = _ref.onChange,
      _ref$hideHEX = _ref.hideHEX,
      hideHEX = _ref$hideHEX === void 0 ? false : _ref$hideHEX,
      _ref$hideRGB = _ref.hideRGB,
      hideRGB = _ref$hideRGB === void 0 ? false : _ref$hideRGB,
      _ref$hideHSB = _ref.hideHSB,
      hideHSB = _ref$hideHSB === void 0 ? false : _ref$hideHSB,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "rcp ".concat(dark ? "rcp-dark" : "rcp-light"),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Saturation.Saturation, {
      width: width,
      height: height,
      color: color,
      onChange: onChange
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "rcp-body",
      style: {
        width: width - 32
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Hue.Hue, {
        width: width - 32,
        color: color,
        onChange: onChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Fields.Fields, {
        color: color,
        hideHEX: hideHEX,
        hideRGB: hideRGB,
        hideHSB: hideHSB,
        onChange: onChange
      })]
    })]
  });
};

var _default = ColorPicker;
exports.default = _default;